export const CALENDAR_TYPES = {
    QUARTER: 3,
    PERIOD: 2,
    WEEK: 1,
    MONTH: 0
};

export const RENT_SET = {
    nazwa: "",
    rodzaj_id: 0,
    ulica: "",
    kod: "",
    miasto: "",
    email: "",
    pesel: "",
    nip: "",
    telefon: "",
    regon: "",
    uwagi: "",
    kierowca1_imie: "",
    kierowca1_ulica: "",
    kierowca1_kod: "",
    kierowca1_miasto: "",
    kierowca1_pesel: "",
    kierowca1_telefon: "",
    kierowca1_prawo_organ: "",
    kierowca1_prawo_data: 0,
    kierowca1_prawo_nr: "",
    kierowca2_imie: "",
    kierowca2_ulica: "",
    kierowca2_kod: "",
    kierowca2_miasto: "",
    kierowca2_pesel: "",
    kierowca2_telefon: "",
    kierowca2_prawo_organ: "",
    kierowca2_prawo_data: 0,
    kierowca2_prawo_nr: "",
    czas_od: "",
    czas_do: "",
    opis: "",
    nr_rej_napr: "",
    limitkm: 0,
    limitkm_rodzaj: 0,
    pool_st_pow_lim_km: 0,
    ryczalt: 0,
    ryczalt_rodzaj: "",
    numer_zlecenia_serwisowego: ""
};

export const CAR_DAMAGE = {
    bagaznik_usz: false,
    bagaznik_opis: "",
    blotnik_przod_lewy_usz: false,
    blotnik_przod_lewy_opis: "",
    blotnik_przod_prawy_usz: false,
    blotnik_przod_prawy_opis: "",
    blotnik_tyl_lewy_usz: false,
    blotnik_tyl_lewy_opis: "",
    blotnik_tyl_prawy_usz: false,
    blotnik_tyl_prawy_opis: "",
    dach_usz: false,
    dach_opis: "",
    drzwi_przod_lewy_usz: false,
    drzwi_przod_lewy_opis: "",
    drzwi_przod_prawy_usz: false,
    drzwi_przod_prawy_opis: "",
    drzwi_tyl_lewy_usz: false,
    drzwi_tyl_lewy_opis: "",
    drzwi_tyl_prawy_usz: false,
    drzwi_tyl_prawy_opis: "",
    kolo_przod_lewy_usz: false,
    kolo_przod_lewy_opis: "",
    kolo_przod_prawy_usz: false,
    kolo_przod_prawy_opis: "",
    kolo_tyl_lewy_usz: false,
    kolo_tyl_lewy_opis: "",
    kolo_tyl_prawy_usz: false,
    kolo_tyl_prawy_opis: "",
    maska_usz: false,
    maska_opis: "",
    slupek_lewy_usz: false,
    slupek_lewy_opis: "",
    slupek_prawy_usz: false,
    slupek_prawy_opis: "",
    swiatlo_przod_usz: false,
    swiatlo_przod_opis: "",
    swiatlo_tyl_usz: false,
    swiatlo_tyl_opis: "",
    szyba_przod_usz: false,
    szyba_przod_opis: "",
    szyba_tyl_usz: false,
    szyba_tyl_opis: "",
    zderzak_przod_usz: false,
    zderzak_przod_opis: "",
    zderzak_tyl_usz: false,
    zderzak_tyl_opis: ""
};
